import { useEffect, useState } from "react";
import Navbar from "../components/navbar.jsx";
import Footer from "../components/footer.jsx";
import BgMental from "../assets/Gallery_Nexus/mentalconditionsback.png";

const conditions = [
  {
    id: "ocd",
    title: "Obsessive Compulsive Disorder (OCD)",
    subtitle: "Taking control of OCD begins with the right support",
    intro:
      "The OCD programme at Nexus is designed to help you understand your symptoms, recognize recurring patterns, and receive structured care tailored specifically to your needs.",
    bullets: [
      "OCD is a neurobiological condition, not a reflection of personality or character.",
      "Obsessions are persistent, intrusive thoughts that feel unwanted and repetitive.",
      "Compulsions are behaviours or rituals that may feel relieving but reinforce the cycle over time.",
      "When symptoms intensify, they can significantly interfere with daily functioning.",
    ],
  },
  {
    id: "addiction",
    title: "Addiction",
    subtitle: "Understanding addiction and finding the right support",
    intro:
      "Addiction recovery begins with structured care and awareness of how patterns form in behaviour and brain reward systems.",
    bullets: [
      "Addiction is a chronic neurobehavioral condition, not a lack of willpower.",
      "Cravings are driven by changes in reward pathways in the brain.",
      "Compulsive use often continues despite negative consequences.",
      "Recovery involves breaking cycles and building new behavioural patterns.",
    ],
    },
    {
        id: "childrenadhd",
        title: "Children ADHD",
        subtitle: "Understanding ADHD and finding the right support",
        intro:
            "ADHD recovery begins with structured care and awareness of how patterns form in behaviour and brain reward systems.",
        bullets: [
            "Children's ADHD is one of the most common neurodevelopmental conditions, and it's very manageable once you understand it.",
            "ADHD is not about being naughty or lazy.",
            "It's about how the brain manages attention, activity, and self-control.Early support makes a big difference.",

            "a) Inattentive Type - trouble focusing",
            "This is often missed because the child is quiet.",

            "b) Hyperactive - Impulsive Type - too much energy and acting without thinking",

            "c) Combined Type - most common, both of the above",
            "Common Symptoms in Children",
            "You need to see a pattern - these behaviors happening often, for more than 6 months, in more than one place like home AND school, and affecting daily life.",
            "✅For Inattention:",
            "* Easily distracted, mind seems elsewhere • Makes careless mistakes in homework • Difficulty following instructions and finishing tasks • Avoids tasks that need long mental effort like homework • Frequently loses things - pencils, books, water bottle • Forgetful in daily activities • Difficulty organizing tasks and time ",
            "✅For Hyperactivity and Impulsivity:",
            "* Constant fidgeting, tapping hands / feet, can't sit still in class • Gets up when expected to stay seated • Runs or climbs excessively, feels like \"driven by a motor\" • Talks excessively, hard to play quietly • Blurts out answers before question is finished • Can't wait for their turn • Interrupts others' games or conversations ",
            "✍️Important Steps to be taken",
            "1. Parent and Teacher Training: This is the first step for young children.Learning how to give clear, short instructions, use routine charts, positive reinforcement, break tasks into small steps, and create a low - distraction study space.",
            "2. Behavioral Therapy: Helps child learn organization, emotional regulation, and social skills.",
            "3. Medication: For moderate to severe cases, a doctor may suggest medicines that help improve focus and impulse control.They are safe when prescribed and monitored properly, but they are not a decision to make alone - please speak with a healthcare professional about risks, benefits, and options for your child.",
            "4. School Support: Seating in front row, extra time, written instructions.",
        ],
    },

  {
    id: "adultadhd",
    title: "Adult ADHD",
    subtitle: "Managing adult ADHD with the right structure",
    intro:
      "Adult ADHD can affect focus, organisation, and emotional regulation, but targeted support helps create clarity and control in daily life.",
    bullets: [
      "Adult ADHD is a neurodevelopmental condition, not laziness or lack of discipline.",
      "Difficulties include attention regulation, impulsivity, and executive functioning challenges.",
      "Symptoms often vary across work, relationships, and personal routines.",
      "Structured strategies and therapy can significantly improve functioning.",
    ],
  },
  {
    id: "depression",
    title: "Depression",
    subtitle: "Understanding depression and the path to recovery",
    intro:
      "Depression can affect thoughts, energy, and motivation, but it is a treatable condition with the right care and support system.",
    bullets: [
      "Depression is a clinical mood disorder, not a personal weakness.",
      "It can involve persistent sadness, fatigue, and loss of interest.",
      "Thought patterns often become negative and self-reinforcing.",
      "Treatment helps restore emotional balance and wellbeing.",
    ],
  },
  {
    id: "anxiety",
    title: "Anxiety",
    subtitle: "Living with anxiety and learning to regain calm",
    intro:
      "Anxiety can create excessive worry and physical tension, but it can be managed with structured therapeutic approaches.",
    bullets: [
      "Anxiety is a mental health condition, not just overthinking.",
      "It involves heightened fear responses and persistent worry.",
      "Physical symptoms may include restlessness, tension, and rapid heartbeat.",
      "Therapy helps retrain thought patterns and stress responses.",
    ],
  },
  {
    id: "womenshealth",
    title: "Women’s Health",
    subtitle: "Supporting holistic women’s health and wellbeing",
    intro:
      "Women’s health includes emotional, hormonal, and psychological wellbeing across different life stages, requiring personalised care and attention.",
    bullets: [
      "Women’s health includes both physical and mental wellbeing factors.",
      "Hormonal changes can influence mood, energy, and cognition.",
      "Life stages such as menstruation, pregnancy, and menopause impact mental health.",
      "Individualised care supports balanced long-term wellness.",
    ],
  },
  {
    id: "bipolar",
    title: "Bipolar Disorder",
    subtitle: "Understanding bipolar disorder and emotional cycles",
    intro:
      "Bipolar disorder involves shifts between mood highs and lows, but stability is achievable with consistent treatment and support.",
    bullets: [
      "Bipolar disorder is a mood regulation condition, not moodiness.",
      "It includes episodes of elevated mood and depressive states.",
      "Energy, sleep, and behaviour patterns may fluctuate significantly.",
      "Treatment helps stabilise mood and improve long-term balance.",
    ],
    },
    {
        id: "schizophrenia",
        title: "Schizophrenia",
        subtitle: "Understanding schizophrenia, symptoms, treatment, and recovery",
        intro:
            "Schizophrenia is a mental health condition where a person has difficulty distinguishing what is real from what is not. It affects thinking, emotions, and behaviour.",
        bullets: [
            "Symptoms of schizophrenia are generally divided into two groups: positive symptoms and negative symptoms.",

            "Positive Symptoms - Extra experiences ADDED: These are called positive symptoms because something extra is present.",

            "Hallucinations: Hearing voices or seeing things that others do not.",
            "Delusions: Strong false beliefs, such as believing someone is plotting against you or that you have special powers.",
            "Disorganized Speech: Incoherent speech or jumping from one topic to another.",
            "Disorganized Behavior: Unusual movements, agitation, or difficulty carrying out daily tasks.",

            "Negative Symptoms - Abilities TAKEN AWAY: These are called negative symptoms because there is a loss or reduction of normal functioning.",

            "Flat Affect: Showing little or no facial expression or having a flat voice.",
            "Avolition: Having little motivation or energy to do things.",
            "Anhedonia: Having little or no interest or pleasure in life.",
            "Alogia: Speaking very little.",
            "Asociality: Withdrawing from family, friends, and social life.",

            "Negative symptoms are often less visible but can have a significant effect on daily life.",

            "Does it have a cure? Schizophrenia has no permanent cure yet, but it is highly treatable. With early and regular treatment, most people can control symptoms, prevent relapse, and live a full life.",

            "Treatment is usually a combination of medication, psychotherapy and rehabilitation, and lifestyle support.",

            "Medication: Antipsychotic medicines prescribed by a psychiatrist can help control positive symptoms.",

            "Psychotherapy & Rehabilitation: Helps manage stress, build life skills, and prevent relapse.",

            "Lifestyle Support: Regular sleep, avoiding cannabis and alcohol, exercise, and strong family support can support recovery.",

            "CBT for Psychosis (CBTp): Helps people challenge or manage distressing beliefs and hallucinations and develop coping skills.",

            "Family Intervention Therapy: Teaches family members how to provide support, communicate better, and reduce stress at home.",

            "Social Skills Training (SST): Helps improve conversation, relationships, and daily life skills.",

            "Cognitive Remediation Therapy (CRT): Uses structured training to help improve memory, attention, and problem-solving.",

            "Supported Employment & Vocational Therapy: Helps people return to work or studies and improve their ability to function independently.",

            "Group Therapy & Peer Support Groups: Can reduce isolation and build confidence through shared experiences and support.",

            "If you notice these signs in someone, encourage them to see a psychiatrist or clinical psychologist early. Early intervention can make a significant difference."
        ],
    },
    {
        id: "ptsd",
        title: "PTSD",
        subtitle: "Understanding PTSD, treatment, and recovery",
        intro:
            "PTSD (Post-Traumatic Stress Disorder) is a mental health condition that can develop after experiencing or witnessing trauma. It can affect thoughts, emotions, sleep, and everyday life.",
        bullets: [
            "PTSD can cause flashbacks, nightmares, avoidance of trauma-related situations, low mood, and feeling constantly on edge.",
            "There is no single pill that permanently cures PTSD, but its symptoms can be treated and managed effectively.",
            "Doctors may prescribe antidepressants such as Sertraline and Paroxetine to help reduce symptoms such as anxiety, depression, and sleep problems.",
            "Trauma-focused therapies such as Cognitive Behavioral Therapy (CBT), Eye Movement Desensitization and Reprocessing (EMDR), and Cognitive Processing Therapy are among the most effective treatments for PTSD.",
            "Treatment may involve a combination of medical care, therapy, healthy coping skills, and support from family, peers, and the community.",
            "With appropriate treatment, support, and ongoing care, recovery from PTSD is very possible."
        ],
    },
    {
        id: "hallucinations",
        title: "Hallucinations",
        subtitle: "Understanding hallucinations and getting the right support",
        intro:
            "A hallucination is when a person sees, hears, feels, smells, or tastes something that is not actually there. The experience can feel completely real to the person, even though others cannot perceive it.",
        bullets: [
            "Hallucinations are not a sign of weakness or a character flaw. They are a health symptom that can happen for many different reasons.",

            "Hearing: Hearing voices or sounds when no one is around.",

            "Seeing: Seeing things, people, or lights that others do not see.",

            "Feeling: Feeling touch or sensations such as crawling on the skin without an apparent physical cause.",

            "Smelling / Tasting: Smelling or tasting something that has no identifiable source.",

            "Hallucinations can be linked to lack of sleep, high stress, high fever, certain medical conditions, mental health conditions, or side effects of some substances or medicines.",

            "You are not alone, and help is available. With the right support and care, things can get better.",

            "If you or someone you know is experiencing hallucinations, talk to a mental health professional for appropriate assessment and support.",

            "At Nexus Mental Health Foundation, we are here to listen and guide you toward the right support."
        ],
    },
    {
        id: "autism",
        title: "Autism Spectrum Disorder (ASD)",
        subtitle: "Understanding childhood autism and supporting every child's strengths",
        intro:
            "At Nexus Mental Health Foundation, we believe every child is unique in how they think, learn, and interact with the world. Autism Spectrum Disorder (ASD) is a neurodevelopmental difference that can affect communication, social interaction, behaviour, and how a child experiences the world. With early understanding and the right support, children can thrive.",
        bullets: [
            "What is Autism Spectrum Disorder (ASD)? Autism affects how a child communicates, socializes, and experiences the world. It is called a spectrum because every child experiences autism differently.",

            "Social Communication: A child may have difficulty making eye contact, responding to their name, understanding emotions, or making friends.",

            "Behavior & Interests: A child may show repeated actions such as hand-flapping or rocking, have a strong preference for routines, or develop intense interests in specific topics or objects.",

            "Sensory Sensitivity: A child may over-react or under-react to sounds, lights, touch, textures, or other sensory experiences.",

            "A diagnosis is not a label to limit a child, but a roadmap to support them better. Early support can make a significant difference.",

            "For the Child - Early Intervention: Therapies such as speech therapy, occupational therapy, and behavioral support can help build communication and daily life skills.",

            "For the Child - Structured & Supportive Learning: Clear routines, visual schedules, and breaking tasks into smaller steps can make learning and everyday activities easier.",

            "For the Child - Celebrate Strengths: Focus on what the child enjoys and does well to build confidence and encourage their strengths.",

            "For Parents & Caregivers - Learn & Observe: Understand your child's triggers, calming strategies, and individual communication style.",

            "For Parents & Caregivers - Be Patient and Consistent: Use positive reinforcement and praise effort, not just results.",

            "For Parents & Caregivers - Seek Support: You are not alone. Support groups, counselors, and special educators can provide guidance and practical support.",

            "If you notice these signs in your child, speak to a pediatrician, child psychologist, or psychiatrist for appropriate guidance and assessment.",

            "At Nexus Mental Health Foundation, we offer awareness, compassionate counseling, and referral support for families. Contact us to learn more."
        ],
    },
    {
        id: "drugdeaddiction",
        title: "Drug De-Addiction",
        subtitle: "Understanding addiction, treatment, and recovery",
        intro:
            "Drug de-addiction is not just about stopping a substance—it is about healing the body, mind, and relationships. Recovery works best when medical support, mental health support, and ongoing recovery support work together.",
        bullets: [
            "Medical Support: This is the first and safest step. People should not try to quit heavy drug or alcohol use alone because withdrawal can sometimes be dangerous.",

            "Assessment & Detox: A doctor assesses the severity of substance use, withdrawal risk, and other health conditions. Detoxification is carried out under medical supervision to manage withdrawal symptoms safely.",

            "Medication-Assisted Treatment (MAT): For some addictions, doctors may use prescribed medicines to reduce cravings and withdrawal symptoms. These medicines should only be prescribed and monitored by a psychiatrist or qualified de-addiction specialist.",

            "Regular Follow-Up: Regular check-ups, laboratory tests, and treatment may be needed for sleep problems, nutritional deficiencies, and health problems affecting organs such as the liver or heart.",

            "Treatment Plan: Treatment should be planned and supervised through a registered de-addiction centre or hospital with appropriate psychiatric and medical support.",

            "If you or someone you know is experiencing severe withdrawal symptoms, an overdose, or a mental health crisis, contact a healthcare professional or the nearest hospital immediately.",

            "Mental Health Support: Drugs are sometimes used as a way of coping with stress, trauma, anxiety, depression, or loneliness. If these underlying issues are not addressed, the risk of relapse can increase.",

            "Counselling: Cognitive Behavioral Therapy (CBT) can help change triggers, craving patterns, and unhelpful thought loops. Motivational Interviewing can help build internal motivation for recovery.",

            "Relapse Prevention: Treatment can help identify triggers, build healthy coping skills, manage cravings, and deal with stress and boredom without returning to substance use.",

            "Support for Other Conditions: Screening for depression, anxiety, PTSD, sleep problems, and other mental health conditions is important so that these conditions can be treated alongside substance use."
        ],
    },

  {
    id: "trichotillomania",
    title: "Trichotillomania",
    subtitle: "Managing trichotillomania through awareness and support",
    intro:
      "Trichotillomania involves repetitive hair-pulling behaviours that can be managed with behavioural strategies and emotional support.",
    bullets: [
      "It is a body-focused repetitive behaviour, not a habit or choice.",
      "Urges often build up before the behaviour occurs.",
      "Hair-pulling may temporarily reduce emotional tension.",
      "Therapy helps reduce urges and build alternative coping responses.",
    ],
  },
  {
    id: "catatonia",
    title: "Catatonia",
    subtitle: "Understanding catatonia and its treatment",
    intro:
      "Catatonia is a serious condition affecting movement and responsiveness, requiring prompt clinical attention and care.",
    bullets: [
      "Catatonia is a neuropsychiatric syndrome, not behavioural refusal.",
      "It may involve reduced movement, speech, or responsiveness.",
      "Symptoms can vary from agitation to complete immobility.",
      "Early treatment improves outcomes significantly.",
    ],
  },
  {
    id: "neurotic",
    title: "Neurotic Disorders",
    subtitle: "Understanding neurotic disorders and emotional patterns",
    intro:
      "Neurotic disorders involve chronic emotional distress and heightened sensitivity to stress, but they can be effectively managed.",
    bullets: [
      "These conditions involve persistent anxiety and emotional reactivity.",
      "Individuals may experience excessive worry or self-doubt.",
      "Physical and psychological stress responses are often heightened.",
      "Therapy supports emotional regulation and resilience.",
    ],
  },
  {
    id: "eatingdisorder",
    title: "Eating Disorder",
    subtitle: "Understanding eating disorder and recovery",
    intro:
      "Eating disorders affect thoughts, emotions, and behaviours around food and body image, but recovery is possible with structured care.",
    bullets: [
      "Eating disorders are serious mental health conditions, not lifestyle choices.",
      "They involve distorted thoughts about food, weight, and body image.",
      "Eating patterns may become restrictive, binge-driven, or irregular.",
      "Recovery focuses on restoring balanced eating and emotional wellbeing.",
    ],
  },
];

function MentalConditions() {
  const [activeSection, setActiveSection] = useState(() => window.location.hash.replace("#", "") || "ocd");

  useEffect(() => {
    const syncSection = () => {
      const id = window.location.hash.replace("#", "") || "ocd";
      setActiveSection(id);
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    };

    syncSection();
    window.addEventListener("hashchange", syncSection);
    window.addEventListener("locationchange", syncSection);

    return () => {
      window.removeEventListener("hashchange", syncSection);
      window.removeEventListener("locationchange", syncSection);
    };
  }, []);

  const handleSectionNavigation = (event, id) => {
    event.preventDefault();
    const nextUrl = `${window.location.pathname}#${id}`;
    window.history.pushState({}, "", nextUrl);
    window.dispatchEvent(new Event("locationchange"));
  };

  return (
    <>
      <Navbar />
      <main className="relative min-h-screen overflow-hidden bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 pt-24 pb-16 px-4 sm:px-6 lg:px-8 glossy-main">
        <div className="absolute inset-0 -z-10">
          <div
            className="absolute inset-0 bg-center bg-cover bg-fixed"
            style={{ backgroundImage: `url(${BgMental})`, opacity: 0.18 }}
          />
          <div className="absolute inset-0 bg-gradient-to-b from-slate-950/85 via-slate-900/75 to-slate-950/95" />
        </div>
        <section className="max-w-7xl mx-auto">
          <div className="rounded-[2rem] bg-slate-800/80 backdrop-blur border border-cyan-500/30 shadow-xl p-8 md:p-12">
            <div className="flex flex-col lg:flex-row gap-10">
              <div className="lg:w-2/3">
                <span className="inline-flex items-center rounded-full bg-cyan-500/20 px-3 py-1 text-sm font-semibold text-cyan-300 border border-cyan-500/50">
                  Mental health support at Nexus
                </span>
                <h1 className="mt-4 text-4xl sm:text-4xl font-black text-white leading-tight">
                  Explore the conditions we support with compassionate, evidence-based care.
                </h1>
                <div className="mt-6 overflow-hidden rounded-[1.5rem] border border-cyan-400/30 bg-slate-900/70 shadow-lg">
                  <img
                    src={BgMental}
                    alt="Mental health support illustration"
                    className="w-full aspect-[15/8] object-cover"
                  />
                  <div className="bg-gradient-to-r from-cyan-500/20 to-orange-500/20 p-4">
                    <p className="text-sm font-medium text-slate-200">
                      Supportive care for emotional wellbeing, recovery, and daily balance.
                    </p>
                  </div>
                </div>
              </div>

              <div className="lg:w-1/3">
                <div className="rounded-2xl border border-cyan-400/50 bg-gradient-to-br from-cyan-500/30 to-orange-500/20 p-6 text-white shadow-lg glossy-card bg-sheen">
                  <h2 className="text-xl font-semibold">Quick navigation</h2>
                  <p className="mt-2 text-sm text-cyan-100">
                    Click any condition to jump directly to its dedicated section.
                  </p>
                  <ul className="mt-4 space-y-2 text-sm">
                    {conditions.map((condition) => (
                      <li key={condition.id}>
                        <a
                          href={`#${condition.id}`}
                          onClick={(event) => handleSectionNavigation(event, condition.id)}
                          className={`block rounded-lg px-3 py-2 transition ${activeSection === condition.id ? "bg-white text-orange-500" : "bg-white/10 text-white hover:bg-white/20"}`}
                        >
                          {condition.title}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-10 grid gap-8 lg:grid-cols-[280px_minmax(0,1fr)]">
            <aside className="lg:sticky lg:top-24 h-fit rounded-3xl border border-cyan-500/30 bg-slate-800/80 p-5 shadow-md glossy-card">
              <h3 className="text-lg font-semibold text-white">Conditions</h3>
              <ul className="mt-4 space-y-2">
                {conditions.map((condition) => (
                  <li key={condition.id}>
                    <a
                      href={`#${condition.id}`}
                      onClick={(event) => handleSectionNavigation(event, condition.id)}
                      className={`block rounded-xl px-3 py-3 text-sm font-medium transition ${activeSection === condition.id ? "bg-orange-500 text-white shadow" : "text-slate-300 hover:bg-slate-700 hover:text-cyan-300"}`}
                    >
                      {condition.title}
                    </a>
                  </li>
                ))}
              </ul>
            </aside>

            <div className="space-y-8">
              {conditions.map((condition) => (
                <section
                  key={condition.id}
                  id={condition.id}
                  className="rounded-[1.75rem] border border-cyan-500/20 bg-slate-800/60 p-7 shadow-md transition hover:shadow-lg glossy-card bg-sheen"
                >
                  <div className="flex flex-wrap items-center justify-between gap-3">
                    <div>
                      <p className="text-sm font-semibold uppercase tracking-[0.2em] text-cyan-400">
                        {condition.title}
                      </p>
                      <h2 className="mt-2 text-2xl sm:text-3xl font-bold text-white">{condition.subtitle}</h2>
                    </div>
                    <span className="rounded-full border border-orange-400/50 bg-orange-500/20 px-3 py-1 text-sm font-medium text-orange-300">
                      Tailored support
                    </span>
                  </div>

                  <p className="mt-5 text-lg text-slate-300">{condition.intro}</p>

                  <ul className="mt-6 space-y-3">
                    {condition.bullets.map((bullet) => (
                      <li key={bullet} className="flex items-start gap-3 rounded-xl bg-slate-700/50 px-4 py-3 text-slate-200">
                        <span className="mt-1 h-2.5 w-2.5 flex-none rounded-full bg-cyan-400" />
                        <span>{bullet}</span>
                      </li>
                    ))}
                  </ul>
                </section>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}

export default MentalConditions;
